import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { useDispatch } from 'react-redux';
import {
    MDBModal,
    MDBModalDialog,
    MDBModalContent,
    MDBModalBody,
} from 'mdb-react-ui-kit';
import { alertActions, authActions } from '../../_store';
import KredGuruSection from '../../_components/kredGuruSection/kredGuruSection';
import SuccessMessage from '../../_components/successMessage/successMessage';
import InputErrorMessage from '../../_components/inputMessages/inputErrorMessage/inputErrorMessage';
import ErrorMessage from '../../_components/errorMessage/errorMessage';

export { OtpVerify };

function OtpVerify() {
    // Defaults
    const [searchParams] = useSearchParams();
    const dispatch = useDispatch();

    // Query Params
    const type = searchParams.get('type');
    const migrated = searchParams.get('migrated');
    const id = searchParams.get('id');

    // Initial setup for navigation props
    dispatch(
        authActions.setNavProps({
            title: 'LOGIN TO SPLENDI',
            button: 'Register',
            action: '../register',
            status: "Don't have an account?",
        })
    );

    // State
    const [isResendLoading, setIsResendLoading] = useState(false);
    const [isSuccessResendOtp, setIsSuccessResendOtp] = useState(false);
    const [isSubmitting, setisSubmitting] = useState(false);
    const [showResetModal, setShowResetModal] = useState(true);
    const [otpError, setOtpError] = useState(false);
    const [otp, setOtp] = useState(null);
    const [errorLogin, setErrorLogin] = useState(null);

    const otpSchema = Yup.object().shape({
        otp: Yup.string().required('OTP is required'),
    });

    const { register, handleSubmit, formState } = useForm({
        resolver: yupResolver(otpSchema),
    });

    useEffect(() => {
        setIsSuccessResendOtp(false);
        setOtpError(false);
        setOtp(null);
        setisSubmitting(false);
        setErrorLogin(null);

        if (id && migrated && migrated === 'true') {
            setShowResetModal(true);
        } else {
            setShowResetModal(false);
        }
    }, []);

    const onOTP = async (e) => {
        e.preventDefault();
        dispatch(
            authActions.setNavProps({
                title: 'ONE TIME PASSCODE',
                button: 'Login',
                action: '../login',
                status: 'Already signed up?',
            })
        );

        if (otp === null || otp === undefined || otp === '') {
            setOtpError(true);
            return null;
        }

        setErrorLogin(null);
        setisSubmitting(true);
        if (type === 'registration') {
            // OTP Flow When A user Is First Registering

            try {
                const response = await dispatch(
                    authActions.otpReg({ otp })
                ).unwrap();
                if (response && response.statusCode === 400) {
                    setErrorLogin(response.message);
                }
                setisSubmitting(false);
            } catch (error) {
                setisSubmitting(false);
                dispatch(alertActions.error(error));
            }
        } else {
            // OTP Flow When A user Is Login in with an existing account
            if (id && migrated && migrated === 'true') {
                // Validate OTP For Migrated USERS
                try {
                    const response = await dispatch(
                        authActions.otpMigrateValidate({ otp })
                    ).unwrap();
                    if (response && response.statusCode === 400) {
                        setErrorLogin(response.message);
                    }
                    setisSubmitting(false);
                } catch (error) {
                    setisSubmitting(false);
                    dispatch(alertActions.error(error));
                }
            } else {
                // Validate OTP For USERS already on the system
                try {
                    const response = await dispatch(
                        authActions.otp({ otp })
                    ).unwrap();
                    if (response && response.statusCode === 400) {
                        setErrorLogin(response.message);
                    }
                    setisSubmitting(false);
                } catch (error) {
                    setisSubmitting(false);
                    dispatch(alertActions.error(error));
                }
            }
        }
    };

    const resendOtp = async () => {
        const email = localStorage.getItem('email');

        if (!email) {
            return null;
        }

        setIsResendLoading(true);
        try {
            const response = await dispatch(
                authActions.resendOtp({ email })
            ).unwrap();

            setIsResendLoading(false);

            if (response && response.statusCode === 400) {
                setErrorLogin(response.message);
            } else {
                setIsSuccessResendOtp(true);
            }
        } catch (error) {
            dispatch(alertActions.error(error));
            setIsResendLoading(false);
            setIsSuccessResendOtp(false);
        }
    };

    const toggleOpen = () => setShowResetModal(!showResetModal);

    const renderTemplate = () => {
        return (
            <div className='card-body'>
                <h2 className='card-header no-border text-center'>
                    WE SENT YOU A OTP
                </h2>
                <p
                    className='mt-4 mb-4 text-center mx-auto'
                    style={{ wordWrap: 'break-word', maxWidth: '350px' }}
                >
                    A One Time Passcode was sent to your cellphone number.
                    Please enter the 6-Digit code or ask for it to be re-sent.
                </p>
                {errorLogin ? (
                    <div className='mb-3 ml-6'>
                        <ErrorMessage message={errorLogin} />
                    </div>
                ) : null}
                {isSuccessResendOtp ? (
                    <div className='mb-3 ml-6'>
                        <SuccessMessage message='An OTP has been sent via SMS' />
                    </div>
                ) : null}
                <form onSubmit={onOTP}>
                    <div className='mb-3 ml-6'>
                        <label className='form-label'>Enter OTP</label>
                        <input
                            name='otp'
                            type='text'
                            {...register('otp')}
                            className={`form-control ${
                                otpError ? 'is-invalid' : ''
                            }`}
                            onChange={(e) => {
                                setOtp(e.target.value);
                                setIsSuccessResendOtp(false);
                                setOtpError(false);
                            }}
                        />
                        {otpError === true ? (
                            <div className='mt-3'>
                                <InputErrorMessage
                                    message={'OTP is required'}
                                />
                            </div>
                        ) : null}
                    </div>
                    <div className='d-grid gap-2 ml-6'>
                        <button
                            disabled={isSubmitting}
                            className='btn btn-black w-100 text-center'
                        >
                            {isSubmitting && (
                                <span className='spinner-border spinner-border-sm me-1'></span>
                            )}
                            FINISH
                        </button>
                        <button
                            type='button'
                            onClick={resendOtp}
                            disabled={isResendLoading}
                            className='btn btn-custom-1 mb-2 w-100'
                        >
                            {isResendLoading && (
                                <span className='spinner-border spinner-border-sm me-1'></span>
                            )}
                            RESEND OTP
                        </button>
                        <p className='mt-2'>
                            If your mobile number has changed, please contact
                            our team on{' '}
                            <a
                                style={{ textDecoration: 'none' }}
                                href='mailto:info@splendi.co.za'
                            >
                                info@splendi.co.za
                            </a>{' '}
                            to update it.
                        </p>
                    </div>
                </form>
            </div>
        );
    };

    return (
        <div className='card no-border m-md-3 pt-4 pb-5 d-flex align-items-center'>
            {renderTemplate()}

            {/* Migrated User Reset Password Modal */}

            <MDBModal
                staticBackdrop
                open={showResetModal}
                onClose={() => setShowResetModal(false)}
                tabIndex='-1'
            >
                <MDBModalDialog size='lg'>
                    <MDBModalContent>
                        <MDBModalBody className='p-5'>
                            <KredGuruSection toggleModal={toggleOpen} />
                        </MDBModalBody>
                    </MDBModalContent>
                </MDBModalDialog>
            </MDBModal>
        </div>
    );
}
